import React , { useEffect, useMemo, useRef, useState, useImperativeHandle } from 'react';
import { isNull, isString } from '../../utils/obj-utils';
import classNames from "classnames";
import _ from 'lodash';
import gsap from 'gsap';
import './style.scss';
const FlippedNumber = ({ index, activeIndex, number, delay = 1000, speed=2000, offset = 0.9 }) => {
  const tl = useRef(null);
  const inView = useRef(null);
  const rootEl = useRef(null);
  const numbers = useMemo(() => {
    const result = [];
    if(!isString(number)) number = number.toString();
    for (let c of number) {
      if (isNaN(c)) {
        result.push(c);
      } else {
        result.push(Number(c));
      }
    }
    return result;
  });
  const methods = {
    initCards(triggeredByResize) {
      inView.current = false;
      const cards = gsap.utils.toArray(rootEl.current.querySelectorAll('.e-flipped-number__card'));
      if (cards.length === 0) return;
      const cardRect = cards[0].getBoundingClientRect();
      tl.current = new gsap.timeline({
        paused: true
      });
      for (let card of cards) {
        const number = Number(card.dataset['number']);
        const cardFlow = card.querySelector('.e-flipped-number__card-flow');
        let cardHtml = '';
        for (let i = 0; i < 10; i++) {
          for (let j = 0; j < 10; j++) {
            cardHtml += `<span>${j}</span>`;
          }
        }
        card.style.height = cardRect.height + 'px';
        card.style.overflow = 'hidden';
        cardFlow.style.width = cardRect.width + 3 + 'px';
        cardFlow.innerHTML = cardHtml;
        gsap.killTweensOf(cardFlow);
        tl.current.fromTo(
          cardFlow,
          {
            translateY: 0
          },
          {
            translateY: -cardRect.height * (number + Math.max(Math.floor(Math.random() * 5), 1) * 10) + 'px',
            // delay: triggeredByResize ? 0 : delay / 1000,
            stepper: 0.3,
            duration: speed / 1000,
            onComplete() {
              cardFlow.innerHTML = `<span>${number}</span>`;
              cardFlow.style.transform = '';
            }
          },
          0
        );
      }
    },
    onScroll() {
      methods.checkPlayable();
    },
    checkPlayable() {
      const winHeight = window.outerHeight;
      const container = rootEl.current;
      const rect = container.getBoundingClientRect();
      let offsetTop = 0.9 * winHeight;
      if (!isNull(offset)) {
        if (isString(offset) && offset.endsWith('%')) {
          offsetTop = (parseInt(offset) * winHeight) / 100;
        } else if (!isNaN(offset)) {
          offsetTop = parseInt(offset);
        }
      }
      const _inView = rect.top <= offsetTop;
      if (inView !== _inView) {
        inView.current = _inView;
        if (inView) {
          methods.play();
        } else if (rect.bottom < 0 || rect.top > winHeight) {
          methods.reset();
        }
      }
    },
    play() {
      if(tl.current) {
        tl.current.play();
      }
    },
    reset(triggeredByResize) {
      if(tl.current) {
        tl.current.pause();
        methods.initCards(triggeredByResize);
      }
    },
    onResize: _.debounce(() => {
      methods.reset(true);
      methods.checkPlayable();
    }, 100)
  };
  useEffect(()=> {
    methods.initCards();
    methods.onScroll();
    window.addEventListener('scroll', methods.onScroll);
    return () => {
      window.removeEventListener('scroll', methods.onScroll);
    };
  }, []);
  return (
    <div className="e-flipped-number" ref={e => rootEl.current = e}>
      {numbers.map((n, index) => (
        <div className={classNames("e-flipped-number__item",isNaN(n)? 'other' : null)} key={index}>
          {isNaN(n)?
            <div className="e-flipped-number__other" v-if="isNaN(n)">
              {n}
            </div>:
            <div className="e-flipped-number__card" data-number={n}>
              <div className="e-flipped-number__card-flow">
                <span>0</span>
              </div>
            </div>
          }
        </div>
      ))}
    </div>
  )
}
export default FlippedNumber;
